export type Locale = 'fi-FI' | 'sv-SE' | 'en-US'

export const LOCALES: Locale[] = ['fi-FI', 'sv-SE', 'en-US']

export const isLocale = (value: unknown): value is Locale => LOCALES.includes(value as Locale)
